import { useState, useEffect } from 'react';
import { useAuth } from '../contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import { nettoyerHtml } from '../utils/nettoyerHtml';

const API = process.env.REACT_APP_API_URL || '/api';
const getImgUrl = (p) => !p ? null : p.startsWith('http') ? p : `${API.replace('/api', '')}${p.startsWith('/') ? p : '/' + p}`;

const SearchIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <circle cx="11" cy="11" r="8"></circle><path d="m21 21-4.35-4.35"></path>
  </svg>
);
const CalendarIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <rect x="3" y="4" width="18" height="18" rx="2" ry="2"></rect>
    <line x1="16" y1="2" x2="16" y2="6"></line><line x1="8" y1="2" x2="8" y2="6"></line>
    <line x1="3" y1="10" x2="21" y2="10"></line>
  </svg>
);
const UserIcon = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"></path><circle cx="12" cy="7" r="4"></circle>
  </svg>
);
const ArrowLeftIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
    <line x1="19" y1="12" x2="5" y2="12"></line><polyline points="12 19 5 12 12 5"></polyline>
  </svg>
);
const WhatsAppIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M17.472 14.382c-.297-.149-1.758-.867-2.03-.967-.273-.099-.471-.148-.67.15-.197.297-.767.966-.94 1.164-.173.199-.347.223-.644.075-.297-.15-1.255-.463-2.39-1.475-.883-.788-1.48-1.761-1.653-2.059-.173-.297-.018-.458.13-.606.134-.133.298-.347.446-.52.149-.174.198-.298.298-.497.099-.198.05-.371-.025-.52-.075-.149-.669-1.612-.916-2.207-.242-.579-.487-.5-.669-.51-.173-.008-.371-.01-.57-.01-.198 0-.52.074-.792.372-.272.297-1.04 1.016-1.04 2.479 0 1.462 1.065 2.875 1.213 3.074.149.198 2.096 3.2 5.077 4.487.709.306 1.262.489 1.694.625.712.227 1.36.195 1.871.118.571-.085 1.758-.719 2.006-1.413.248-.694.248-1.289.173-1.413-.074-.124-.272-.198-.57-.347m-5.421 7.403h-.004a9.87 9.87 0 01-5.031-1.378l-.361-.214-3.741.982.998-3.648-.235-.374a9.86 9.86 0 01-1.51-5.26c.001-5.45 4.436-9.884 9.888-9.884 2.64 0 5.122 1.03 6.988 2.898a9.825 9.825 0 012.893 6.994c-.003 5.45-4.437 9.884-9.885 9.884m8.413-18.297A11.815 11.815 0 0012.05 0C5.495 0 .16 5.335.157 11.892c0 2.096.547 4.142 1.588 5.945L.057 24l6.305-1.654a11.882 11.882 0 005.683 1.448h.005c6.554 0 11.89-5.335 11.893-11.893a11.821 11.821 0 00-3.48-8.413Z"/>
  </svg>
);
const FacebookIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M24 12.073c0-6.627-5.373-12-12-12s-12 5.373-12 12c0 5.99 4.388 10.954 10.125 11.854v-8.385H7.078v-3.47h3.047V9.43c0-3.007 1.792-4.669 4.533-4.669 1.312 0 2.686.235 2.686.235v2.953H15.83c-1.491 0-1.956.925-1.956 1.874v2.25h3.328l-.532 3.47h-2.796v8.385C19.612 23.027 24 18.062 24 12.073z"/>
  </svg>
);
const EmailIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M20 4H4c-1.1 0-1.99.9-1.99 2L2 18c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6c0-1.1-.9-2-2-2zm0 4l-8 5-8-5V6l8 5 8-5v2z"/>
  </svg>
);
const CopyIcon = () => (
  <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
    <path d="M16 1H4c-1.1 0-2 .9-2 2v14h2V3h12V1zm3 4H8c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h11c1.1 0 2-.9 2-2V7c0-1.1-.9-2-2-2zm0 16H8V7h11v14z"/>
  </svg>
);

const CATEGORY_COLORS = {
  'Lecture Biblique': 'bg-green-100 text-green-800',
  'Evènements':       'bg-purple-100 text-purple-800',
  'Annonces':         'bg-yellow-100 text-yellow-800',
  'Actus':            'bg-blue-100 text-blue-800',
  'Prières':          'bg-pink-100 text-pink-800',
};
const CATEGORY_LABELS = {
  'Lecture Biblique': 'Lectures',
};
const categoryColor = (cat) => CATEGORY_COLORS[cat] || 'bg-gray-100 text-gray-700';
const categoryLabel = (cat) => CATEGORY_LABELS[cat] || cat || 'Article';

function ShareButtons({ article }) {
  const url = `${window.location.origin}/blog`;
  const title = article.titre;
  const share = (platform) => {
    const urls = {
      whatsapp: `https://wa.me/?text=${encodeURIComponent(String.fromCodePoint(0x1F4D6) + ' *' + title + '*\n\nLire l\'article complet :\n' + url)}`,
      facebook: `https://www.facebook.com/sharer/sharer.php?u=${encodeURIComponent(url)}`,
      email:    `mailto:?subject=${encodeURIComponent(title)}&body=${encodeURIComponent(url)}`,
    };
    if (platform === 'copy') { navigator.clipboard.writeText(url); alert('Lien copié !'); return; }
    if (urls[platform]) window.open(urls[platform], '_blank', 'width=600,height=400');
  };
  return (
    <div className="flex gap-2 items-center">
      <span className="text-sm text-gray-600 font-medium">Partager :</span>
      {[['whatsapp','text-green-600 hover:bg-green-50',<WhatsAppIcon/>],
        ['facebook','text-blue-600 hover:bg-blue-50',<FacebookIcon/>],
        ['email','text-gray-600 hover:bg-gray-100',<EmailIcon/>],
        ['copy','text-gray-600 hover:bg-gray-100',<CopyIcon/>]].map(([p,cls,icon]) => (
        <button key={p} onClick={() => share(p)} className={`p-2 ${cls} rounded-lg transition-colors`} title={p}>{icon}</button>
      ))}
    </div>
  );
}

export default function PublicBlog() {
  const { isAuthenticated } = useAuth();
  const navigate = useNavigate();

  const [articles, setArticles]       = useState([]);
  const [loading, setLoading]         = useState(true);
  const [error, setError]             = useState('');
  const [selectedArticle, setSelectedArticle] = useState(null);
  const [searchTerm, setSearchTerm]   = useState('');
  const [filterCategory, setFilterCategory] = useState('all');

  useEffect(() => {
    fetch(`${API}/blog/posts?limit=50&page=1`)
      .then(r => r.json())
      .then(data => {
        if (Array.isArray(data)) {
          setArticles(data);
          // Ouvrir l'article ciblé par ?article=ID
          const params = new URLSearchParams(window.location.search);
          const targetId = params.get('article');
          if (targetId) {
            const found = data.find(a => String(a.id) === targetId);
            if (found) setSelectedArticle(found);
          }
        } else {
          setError('Impossible de charger les articles.');
        }
      })
      .catch(() => setError('Erreur de connexion au serveur.'))
      .finally(() => setLoading(false));
  }, []);

  const categories = [...new Set(articles.map(a => a.categorie).filter(Boolean))];

  const filtered = articles.filter(a => {
    const q = searchTerm.toLowerCase();
    const matchSearch = !q || a.titre?.toLowerCase().includes(q) || a.resume?.toLowerCase().includes(q);
    const matchCat = filterCategory === 'all' || a.categorie === filterCategory;
    return matchSearch && matchCat;
  });

  const formatDate = (d) => d ? new Date(d).toLocaleDateString('fr-FR', { year:'numeric', month:'long', day:'numeric' }) : '';
  const authorName = (a) => [a.prenom, a.nom].filter(Boolean).join(' ') || 'EECF';

  const Header = () => (
    <header className="mb-8 flex justify-between items-center">
      <div>
        <h1 className="text-3xl font-bold text-gray-900 mb-1">Actualités EECF</h1>
        <p className="text-gray-600">Découvrez nos derniers articles</p>
      </div>
      {!isAuthenticated
        ? <button onClick={() => navigate('/login')} className="whitespace-nowrap flex-shrink-0 px-6 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 transition-colors">Se connecter</button>
        : <button onClick={() => navigate('/dashboard')} className="whitespace-nowrap flex-shrink-0 px-6 py-2 bg-green-600 text-white rounded-lg hover:bg-green-700 transition-colors">Tableau de bord</button>
      }
    </header>
  );

  // Vue article
  if (selectedArticle) {
    return (
      <div className="min-h-screen bg-gray-50">
        <div className="max-w-4xl mx-auto p-6">
          <Header />
          <button onClick={() => setSelectedArticle(null)} className="flex items-center gap-2 text-blue-600 hover:text-blue-700 font-medium mb-6">
            <ArrowLeftIcon /> Retour aux articles
          </button>
          <article className="bg-white rounded-lg shadow-sm overflow-hidden">
            {selectedArticle.image_principale && (
              <img
                src={getImgUrl(selectedArticle.image_principale)}
                alt={selectedArticle.titre}
                className="w-full object-contain bg-gray-50"
                style={{ maxHeight: '480px' }}
              />
            )}
            <div className="p-8">
              <span className={`px-3 py-1 rounded-full text-xs font-medium ${categoryColor(selectedArticle.categorie)}`}>
                {categoryLabel(selectedArticle.categorie)}
              </span>
              <h1 className="text-3xl font-bold text-gray-900 mt-4 mb-4">{selectedArticle.titre}</h1>
              <div className="flex flex-wrap gap-4 text-sm text-gray-600 mb-6 pb-6 border-b">
                <span className="flex items-center gap-1"><UserIcon />{authorName(selectedArticle)}</span>
                <span className="flex items-center gap-1"><CalendarIcon />{formatDate(selectedArticle.date_publication)}</span>
              </div>
              <div className="mb-6 pb-6 border-b"><ShareButtons article={selectedArticle} /></div>
              {selectedArticle.resume && (
                <p className="text-xl text-gray-700 mb-8 italic leading-relaxed">{selectedArticle.resume}</p>
              )}
              {selectedArticle.audio_url && (
                <audio controls src={getImgUrl(selectedArticle.audio_url)} className="w-full mb-8" />
              )}
              <div
                className="text-gray-800 leading-relaxed text-base prose max-w-none"
                dangerouslySetInnerHTML={{ __html: nettoyerHtml(selectedArticle.contenu) }}
              />
              <div className="mt-8 pt-6 border-t"><ShareButtons article={selectedArticle} /></div>
            </div>
          </article>
        </div>
      </div>
    );
  }

  // Vue liste
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto p-6">
        <Header />

        {!isAuthenticated && (
          <div className="bg-green-700 text-white rounded-xl p-6 mb-8 flex flex-col md:flex-row items-center justify-between gap-4 shadow-md">
            <div>
              <h2 className="text-xl font-bold mb-1">Rejoignez la communauté EECF</h2>
              <p className="text-green-100 text-sm">Devenez membre et accédez à tous les services de la paroisse.</p>
            </div>
            <button onClick={() => navigate('/enrollment')} className="whitespace-nowrap px-8 py-3 bg-white text-green-700 font-bold rounded-lg hover:bg-green-50 transition-colors text-base shadow">
              Faire une demande d'adhésion
            </button>
          </div>
        )}

        <div className="bg-white rounded-lg shadow-sm p-6 mb-6">
          <div className="flex flex-col md:flex-row gap-4 mb-6">
            <div className="flex-1 relative">
              <div className="absolute left-3 top-1/2 -translate-y-1/2 text-gray-400"><SearchIcon /></div>
              <input
                type="text"
                placeholder="Rechercher un article..."
                value={searchTerm}
                onChange={e => setSearchTerm(e.target.value)}
                className="w-full pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
              />
            </div>
            <select
              value={filterCategory}
              onChange={e => setFilterCategory(e.target.value)}
              className="px-4 py-2 border border-gray-300 rounded-lg focus:ring-2 focus:ring-blue-500 focus:border-transparent"
            >
              <option value="all">Toutes les catégories</option>
              {categories.map(cat => <option key={cat} value={cat}>{cat}</option>)}
            </select>
          </div>

          {loading && (
            <div className="text-center py-12 text-gray-500">Chargement des articles…</div>
          )}

          {error && (
            <div className="text-center py-12 text-red-500">{error}</div>
          )}

          {!loading && !error && (
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {filtered.map(article => (
                <div
                  key={article.id}
                  className="border border-gray-200 rounded-lg overflow-hidden hover:shadow-lg transition-shadow cursor-pointer flex flex-col"
                  onClick={() => setSelectedArticle(article)}
                >
                  {article.image_principale && (
                    <img
                      src={getImgUrl(article.image_principale)}
                      alt={article.titre}
                      className="w-full object-contain bg-gray-50"
                      style={{ height: '180px' }}
                    />
                  )}
                  <div className="p-5 flex flex-col flex-1">
                    <div className="mb-3">
                      <span className={`px-3 py-1 rounded-full text-xs font-medium ${categoryColor(article.categorie)}`}>
                        {categoryLabel(article.categorie)}
                      </span>
                    </div>
                    <h3 className="text-lg font-semibold text-gray-900 mb-2 hover:text-blue-600 line-clamp-2">
                      {article.titre}
                    </h3>
                    {article.resume && (
                      <p className="text-gray-600 mb-4 line-clamp-3 text-sm flex-1">{article.resume}</p>
                    )}
                    <div className="flex items-center justify-between text-sm text-gray-500 pt-4 border-t mt-auto">
                      <span className="flex items-center gap-1"><UserIcon />{authorName(article)}</span>
                      <span className="flex items-center gap-1"><CalendarIcon />{formatDate(article.date_publication)}</span>
                    </div>
                    <button
                      onClick={e => {
                        e.stopPropagation();
                        const url = `${window.location.origin}/blog?article=${article.id}`;
                        const msg = String.fromCodePoint(0x1F4D6) + ' *' + article.titre + '*\n\n' + (article.resume || '') + '\n\nLire l\'article complet :\n' + url;
                        window.open(`https://wa.me/?text=${encodeURIComponent(msg)}`, '_blank');
                      }}
                      className="mt-3 flex items-center gap-2 text-sm text-green-600 hover:text-green-700 font-medium"
                    >
                      <WhatsAppIcon /> Partager sur WhatsApp
                    </button>
                  </div>
                </div>
              ))}
            </div>
          )}

          {!loading && !error && filtered.length === 0 && (
            <div className="text-center py-12">
              <p className="text-gray-500">Aucun article trouvé</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
